export function SparkleIcon({ ...rest }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...rest}
    >
      {/* Main four-point sparkle */}
      <path d="M11.5 4.5c.7 4.4 2 5.7 6.4 6.4-4.4.7-5.7 2-6.4 6.4-.7-4.4-2-5.7-6.4-6.4 4.4-.7 5.7-2 6.4-6.4Z" />
      {/* Small sparkle, top right */}
      <path d="M18.2 3.2c.28 1.6.72 2.04 2.32 2.32-1.6.28-2.04.72-2.32 2.32-.28-1.6-.72-2.04-2.32-2.32 1.6-.28 2.04-.72 2.32-2.32Z" />
      {/* Dot, bottom left */}
      <circle cx="7.2" cy="17.4" r="1.15" />
    </svg>
  );
}
